<template>
  <table
    class="adminOrderDetailTable"
    :class="{
      box: !isShowTableHeader,
    }"
  >
    <tr
      v-if="isShowTableHeader"
      style="background-color: lightgray;"
    >
      <th colspan="3" style="text-align: left;">
        <span style="margin-left: 5pt;">Rodan設定値</span>
      </th>
    </tr>
    <tr>
      <td style="vertical-align: top;">
        <div>
          <div class="table" style="width: 220pt">
            <div class="row">
              <div class="col th" style="width: 40%">
                共通
              </div>
            </div>
            <div class="row">
              <div class="col th" style="width: 40%">
                梵字・家紋
              </div>
              <div class="col td">
                <span v-if="order.detail && order.detail.sanskritCharacterOrFamilyEmblem">
                  {{
                    order.detail.sanskritCharacterOrFamilyEmblem === "SANSKRIT_CHARACTER"
                      ? order.detail.sanskritCharacter &&
                        order.detail.sanskritCharacter.id !== null
                        ? order.detail.sanskritCharacter.inputCode
                        : ""
                      : order.detail.familyEmblem &&
                        order.detail.familyEmblem.id !== null
                        ? order.detail.familyEmblem.inputCode
                        : ""
                  }}
                </span>
              </div>
            </div>
            <div class="row bottom">
              <div class="col th bottom" style="width: 40%">
                裏梵字
              </div>
              <div class="col td bottom">
                <span
                  v-if="order.detail && order.detail.sanskritCharacterBack"
                >
                  {{
                    order.detail.sanskritCharacterBack &&
                    order.detail.sanskritCharacterBack.id !== null
                      ? order.detail.sanskritCharacterBack.inputCode
                      : ""
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </td>

      <td
        v-for="(column, index) in order.detail.columns"
        v-bind:key="index"
      >
        <div class="table" style="width: 220pt; vertical-align: top;">
          <div class="row">
            <div class="col th" style="width: 40%">
              {{ index === 0 ? "一" : "二" }}霊
            </div>
          </div>
          <div class="row">
            <div class="col th" style="width: 40%">
              戒名
            </div>
            <div class="col td">
              {{ buddhistNames[index] }}
            </div>
          </div>
          <div class="row">
            <div class="col th" style="width: 40%">
              位表記
            </div>
            <div class="col td">
              {{ commonUnderCharacters }}
              <!-- {{
                order.detail.underCharactersPlacement &&
                order.detail.underCharactersPlacement === "CENTER"
                  ? commonUnderCharacters
                  : underCharacters[index]
              }} -->
            </div>
          </div>
          <div class="row">
            <div class="col th" style="width: 40%">
              没年
            </div>
            <div class="col td">
              {{
                dateOfDeathYear.length
                  ? dateOfDeathYear[index]
                  : dateOfDeathYear
              }}
            </div>
          </div>
          <div class="row">
            <div class="col th" style="width: 40%">
              没月日
            </div>
            <div class="col td">
              {{
                dateOfDeathDay.length
                  ? dateOfDeathDay[index]
                  : dateOfDeathDay
              }}
            </div>
          </div>
          <div class="row">
            <div class="col th" style="width: 40%">
              没表記
            </div>
            <div class="col td">
              {{ commonDiedCharacter || diedCharacter[index] || "" }}
            </div>
          </div>
          <div class="row">
            <div class="col th" style="width: 40%">
              俗名・題
            </div>
            <div class="col td">
              {{
                commonSecularNamePrefix || secularNamePrefix[index] || ""
              }}
            </div>
          </div>
          <div class="row">
            <div class="col th" style="width: 40%">
              俗名
            </div>
            <div class="col td">
              {{ secularNames[index] || "" }}
            </div>
          </div>
          <div class="row">
            <div class="col th" style="width: 40%">
              没年齢・題
            </div>
            <div class="col td">
              {{ commonAgeAtDeathPrefix || ageAtDeathPrefix[index] || "" }}
            </div>
          </div>
          <div class="row">
            <div class="col th" style="width: 40%">
              没年齢
            </div>
            <div class="col td">
              {{ ageAtDeath[index] || "" }}
            </div>
          </div>
          <div class="row">
            <div class="col th bottom" style="width: 40%">
              年齢単位
            </div>
            <div class="col td bottom">
              {{ commonAgeUnitCharacter || ageUnitCharacter[index] || "" }}
            </div>
          </div>
        </div>
      </td>
    </tr>
  </table>
</template>

<script>
import VariantCharacterUsecase from "@/usecases/variantCharacter.usecase";
import VariantCharacterGroupUsecase from "@/usecases/variantCharacterGroup.usecase";

export default {
  name: "AdminOrderDetailRodanSetValues",
  props: {
    order: {
      type: Object,
      default: () => {},
    },
    isShowTableHeader: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      buddhistNames: ["", ""],
      secularNames: ["", ""],
      diedCharacter: ["", ""],
      dateOfDeath: ["", ""],
      dateOfDeathYear: ["", ""],
      dateOfDeathDay: ["", ""],
      ageAtDeath: ["", ""],
      ageAtDeathPrefix: ["", ""],
      underCharacters: ["", ""],
      secularNameSuffix: ["", ""],
      ageUnitCharacter: ["", ""],
      secularNamePrefix: ["", ""],
      commonAgeAtDeathPrefix: "",
      commonSecularNamePrefix: "",
      commonDiedCharacter: "",
      commonAgeUnitCharacter: "",
      commonUnderCharacters: "",
    };
  },
  computed: {
  },
  watch: {
    order: function () {
      this.set();
    },
  },
  created () {
  },
  mounted () {
    this.set();
  },
  methods: {
    async set () {
      try {
        this.buddhistNames = await this.getStingArrayWithVariantCharacterCode(
          "buddhistName"
        );
        this.secularNames = await this.getStingArrayWithVariantCharacterCode(
          "secularName"
        );
        this.dateOfDeath = await this.getStingArrayWithVariantCharacterCode(
          "dateOfDeath"
        );
        this.dateOfDeathYear = await this.getSubStingArrayWithVariantCharacterCode(
          "dateOfDeath",
          "dateOfDeathYear",
          "",
          "年"
        );
        this.dateOfDeathDay = await this.getSubStingArrayWithVariantCharacterCode(
          "dateOfDeath",
          "dateOfDeathDay",
          "年",
          "日"
        );
        this.ageAtDeath = await this.getStingArrayWithVariantCharacterCode(
          "ageAtDeath"
        );
        // this.underCharacters = await this.getStingArrayWithVariantCharacterCode(
        //   "underCharacters"
        // );
        this.secularNameSuffix = await this.getStingArrayWithVariantCharacterCode(
          "secularNameSuffix"
        );
        this.ageUnitCharacter = await this.getStingArrayWithVariantCharacterCode(
          "ageUnitCharacter"
        );
        this.ageAtDeathPrefix = await this.getStingArrayWithVariantCharacterCode(
          "ageAtDeathPrefix"
        );
        this.secularNamePrefix = await this.getStingArrayWithVariantCharacterCode(
          "secularNamePrefix"
        );
        this.commonSecularNamePrefix = await this.getStringWithVariantCharacterCode(
          this.order.detail.secularNamePrefix
        );
        this.commonAgeAtDeathPrefix = await this.getStringWithVariantCharacterCode(
          this.order.detail.ageAtDeathPrefix
        );
        this.commonAgeUnitCharacter = await this.getStringWithVariantCharacterCode(
          this.order.detail.ageUnitCharacter
        );
        this.commonDiedCharacter = await this.getStringWithVariantCharacterCode(
          this.order.detail.diedCharacter
        );
        this.commonUnderCharacters = await this.getStringWithVariantCharacterCode(
          this.order.detail.underCharacters
        );
      } catch (err) {
        // apiErrorHandler(this, err);
        // console.log(err);
      }
    },

    async getStingArrayWithVariantCharacterCode (item) {
      const results = [];
      if (
        !(
          this.order.detail.columns &&
          this.order.detail.columns.length &&
          this.order.detail.columns[0] &&
          this.order.detail.columns[0][item]
        )
      ) {
        return ["", ""];
      }

      if (this.order.detail.columns) {
        for (let i = 0; i < this.order.detail.columns.length; i++) {
          if (this.order.detail.columns[i][item]) {
            const stringDatas = this.order.detail.columns[i][item];
            const value = await this.getStringWithVariantCharacterCode(stringDatas);

            results.push(value);
          } else {
            results.push("");
          }
        }
      }

      return results.length ? results : ["", ""];
    },

    async getStringWithVariantCharacterCode (item) {
      let result = "";

      if (!item) {
        return result;
      }

      if (
        this.order.detail &&
        this.order.detail.columns &&
        item &&
        item.length
      ) {
        const valueDatas = item;
        const resultCharacters = [];
        for (const characterData of valueDatas) {
          if (characterData.variantCharacterId) {
            const variantCharacterRecord = await variantCharacterUsecase.getVariantCharacter(
              {
                id: characterData.variantCharacterId,
              }
            );
            if (variantCharacterRecord) {
              resultCharacters.push(variantCharacterRecord.inputCode);
            }
          } else {
            const variantCharacterGroups = await variantCharacterGroupUsecase.getVariantCharacterGroups(
              {
                q: {
                  font: this.order.detail.typography.font,
                  searchConditions: characterData.character,
                },
              }
            );
            if (
              variantCharacterGroups.length &&
              variantCharacterGroups[0].variantCharacters.length
            ) {
              // sortNumberがnullではないものから最初の1つを取得
              const variantCharacterWithSortNumber = variantCharacterGroups[0].variantCharacters.find(
                (vc) => vc.sortNumber !== null && vc.sortNumber !== undefined
              );
              const variantCharacterRecord = variantCharacterWithSortNumber || variantCharacterGroups[0].variantCharacters[0];
              resultCharacters.push(variantCharacterRecord.inputCode);
            } else {
              resultCharacters.push(characterData.character);
            }
          }
        }
        result = resultCharacters.join("");
      }

      return result;
    },

    async getSubStingArrayWithVariantCharacterCode (
      item,
      originalItem,
      startChar = "",
      endChar
    ) {
      const results = [];
      if (
        !(
          this.order.detail.columns &&
          this.order.detail.columns.length &&
          this.order.detail.columns[0] &&
          this.order.detail.columns[0][item]
        )
      ) {
        return ["", ""];
      }

      if (this.order.detail.columns) {
        for (let i = 0; i < this.order.detail.columns.length; i++) {
          if (this.order.detail.columns[i][item]) {
            const stringDatas = this.order.detail.columns[i][item];
            const value = await this.getSubStringWithVariantCharacterCode(
              stringDatas,
              startChar,
              endChar
            );
            results.push(value);
          } else {
            results.push("");
          }
        }
      }
      return results;
    },

    async getSubStringWithVariantCharacterCode (item, startChar = "", endChar) {
      let result = "";
      if (!item) return "";
      if (
        this.order.detail &&
        this.order.detail.columns &&
        item &&
        item.length
      ) {
        const valueDatas = item;
        const resultCharacters = [];
        let start = false;
        let end = false;
        if (startChar === "") start = true;
        for (const characterData of valueDatas) {
          if (start === true && end === false) {
            if (characterData.variantCharacterId) {
              const variantCharacterRecord = await variantCharacterUsecase.getVariantCharacter(
                {
                  id: characterData.variantCharacterId,
                }
              );
              if (variantCharacterRecord) {
                resultCharacters.push(variantCharacterRecord.inputCode);
              }
            } else {
              const variantCharacterGroups = await variantCharacterGroupUsecase.getVariantCharacterGroups(
                {
                  q: {
                    font: this.order.detail.typography.font,
                    searchConditions: characterData.character,
                  },
                }
              );
              if (
                variantCharacterGroups.length &&
                variantCharacterGroups[0].variantCharacters.length
              ) {
                // sortNumberがnullではないものから最初の1つを取得
                const variantCharacterWithSortNumber = variantCharacterGroups[0].variantCharacters.find(
                  (vc) => vc.sortNumber !== null && vc.sortNumber !== undefined
                );
                const variantCharacterRecord = variantCharacterWithSortNumber || variantCharacterGroups[0].variantCharacters[0];
                resultCharacters.push(variantCharacterRecord.inputCode);
              } else {
                resultCharacters.push(characterData.character);
              }
            }
          }
          if (!start && startChar === characterData.character) start = true;
          if (!end && endChar === characterData.character) end = true;
        }
        result = resultCharacters.join("");
      }
      return result;
    },
  },
};

const variantCharacterUsecase = new VariantCharacterUsecase();
const variantCharacterGroupUsecase = new VariantCharacterGroupUsecase();
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.table {
  width: 520pt;
  align-self: center;
  margin: 0.3rem 0 !important;
}
.table .row {
  display: table;
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
}
.table .row .col.empty {
  display: table-cell;
  padding: 0.3rem;
  border: none;
  border-bottom: none;
  text-align: center;
}
.table .row .col.th {
  display: table-cell;
  padding: 0.3rem;
  border: 1px solid black;
  border-bottom: none;
  width: 20%;
  background-color: lightgray;
  text-align: center;
}
.table .row .col.td {
  display: table-cell;
  padding: 0.3rem;
  border: 1px solid black;
  border-bottom: none;
  width: auto;
}
.table .row .col.th.bottom {
  display: table-cell;
  padding: 0.3rem;
  border: 1px solid black;
  width: 20%;
  background-color: lightgray;
  text-align: center;
}
.table .row .col.td.bottom {
  display: table-cell;
  padding: 0.3rem;
  border: 1px solid black;
  width: auto;
}
</style>
